<template>
  <div>
    <gd-modal name="payment-gateway-modal" width="900px" :title="selectedIntegrationTitle
      ? selectedIntegrationTitle
      : $t('frontend_groovesell_paymeny_gateway_list')
      ">
      <div class="overflow-y-auto custom-scrollbars scroll-modal">
        <div class="gs-gateway-picker__body">
          <div class="flex flex-wrap -m-2" v-if="!showIntegrationForm">
            <div v-for="(integration, index) in availableIntegrations" :key="index" class="p-2" :class="integration.name === 'groove_pay' ||
              integration.name === 'groovepay_automated'
              ? 'w-full'
              : 'w-1/4'
              ">
              <div v-if="
                integration.name === 'groove_pay' ||
                integration.name === 'groovepay_automated'
              ">
                <div class="gs-gateway-picker__card gs-gateway-picker__card--wide flex p-4 cursor-pointer relative"
                  @click="
                      handleIntegrationClick(
                        integration.fields,
                        integration.name,
                        integration.display_name
                      )
                      ">
                  <div class="w-32">
                    <img src="@/assets/images/logo/groovepay-integration.png" alt="" />
                    <div class="flex w-full justify-center mt-4">
                      <gs-button variant="primary" size="sm" @click="openGroovepay()">Signup</gs-button>
                    </div>
                  </div>
                  <div class="flex flex-col flex-1 ml-4">
                    <p class="text-lg font-bold mb-2">
                      {{ $t('frontend_product_step3_groovesell_is_best', {
                        appTitle: whitelabelAppData('sell').title, payAppTitle:
                          whitelabelAppData('pay').title
                      }) }}
                    </p>
                    <p class="text-sm mb-2">
                      <span class="font-bold">As Low As 2.85%</span><span class="text-xs">+ $0.25 per transaction for
                        USA</span>
                    </p>
                    <p class="text-sm font-bold mb-2">
                      The best and most affordable way to accept credit cards
                    </p>
                    <p class="text-sm mb-2">
                      {{ $t('groovepay_has_no', { appTitle: whitelabelAppData('pay').title }) }}
                    </p>
                  </div>
                  <div class="absolute top-0 right-0 -mt-6 -mr-6">
                    <img src="@/assets/images/icons/recommended-icon.png" alt="" />
                  </div>
                </div>
              </div>
              <div class="h-full relative" v-if="
                integration.name !== 'groove_pay' &&
                integration.name !== 'groovepay_automated'
              ">
                <div class="gs-gateway-picker__card flex flex-col h-full items-center overflow-hidden p-4"
                  :class="canUseIntegration(integration)
                    ? 'cursor-pointer'
                    : 'pointer-events-none'
                    " @click="
                      handleIntegrationClick(
                        integration.fields,
                        integration.name,
                        integration.display_name
                      )
                      ">
                  <div>
                    <paypal-logo-icon v-if="integration.name == 'paypal' || integration.name == 'paypal_commerce'"
                      class="h-16" />
                    <stripe-logo-icon v-else-if="integration.name == 'stripe'" class="h-16" />
                    <div v-else-if="integration.name == 'commas'"
                      class="h-16 flex items-center text-xl font-bold text-grey-800">ScaleGG Pay</div>
                    <img v-else
                      :src="'https://assets.grooveapps.com/payment-gateway/' + integration.name + '-integration.png'"
                      alt="" class="h-16" />
                  </div>
                  <div class="mt-4">
                    {{ integration.display_name }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="showIntegrationForm">
            <div v-if="
              selectedIntegrationType == 'braintree' ||
              selectedIntegrationType == 'authorize.net'
            " class="gs-gateway-picker__note">
              <info-icon class="gs-gateway-picker__note-icon" />
              <div class="inline">
                Note : For Braintree and Authorize.net payment gateway the
                currency of integration account should match with the funnel
                currency.
              </div>
            </div>
            <div v-if="
              selectedIntegrationType == 'nmi' ||
              selectedIntegrationType == 'paypal'
            " class="gs-gateway-picker__note">
              <info-icon class="gs-gateway-picker__note-icon" />
              <div class="inline">
                Note : For NMI and Paypal we only support USD make sure the
                funnel currency is in USD .
              </div>
            </div>
            <gs-field class="gs-gateway-picker__field" :label="$t('frontend_product_step3_name')">
              <text-input v-model="selectedIntegrationName" :validator="$v.selectedIntegrationName"
                :attribute="$t('frontend_product_step3_name')" class="text-dark text-sm"
                :placeholder="$t('frontend_product_step3_name')" />
            </gs-field>
            <gs-field v-for="(field, index) in formfields" :key="index" class="gs-gateway-picker__field"
              :label="formfields[index].label" :hint="formfields[index].info">
              <commas-environment-select v-if="selectedIntegrationType === 'commas' && field.key === 'environment'"
                v-model="formfields[index].value" :validator="$v.formfields.$each[index].value"
                :attribute="field.label" />
              <text-input v-else v-model="formfields[index].value" :validator="$v.formfields.$each[index].value"
                :attribute="formfields[index].label" class="text-dark text-sm" value="formfields[index].value"
                :placeholder="formfields[index].label" />
            </gs-field>
            <div class="gs-gateway-picker__actions">
              <gs-button variant="outline" @click="backToGateway()">{{ $t('frontend_groovesell_back_to_list') }}</gs-button>
              <gs-button variant="primary" @click="registerIntegration()">{{
                $t('frontend_product_step3_create') }}</gs-button>
            </div>
          </div>
        </div>
      </div>
    </gd-modal>
  </div>
</template>

<style>
/* The gd-modal body has no padding of its own. */
.gs-gateway-picker__body {
  padding: 24px 28px 32px;
  color: var(--gs-foreground);
}

.gs-gateway-picker__card {
  color: var(--gs-foreground);
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-md);
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

.gs-gateway-picker__card:hover {
  border-color: var(--gs-primary);
  box-shadow: var(--gs-shadow-sm);
}

.gs-gateway-picker__card--wide:hover {
  box-shadow: var(--gs-shadow-md);
}

.gs-gateway-picker__note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 18px;
  padding: 10px 12px;
  color: var(--gs-muted-foreground);
  font-size: 13px;
  font-weight: 600;
  background: var(--gs-surface-subtle);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-md);
}

.gs-gateway-picker__note-icon {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  margin-top: 2px;
  fill: currentColor;
}

.gs-gateway-picker__field {
  margin-bottom: 18px;
}

.gs-gateway-picker__actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

/* Token-align the gd-modal chrome for the add-gateway modal (CSS only). */
.gd-modal.payment-gateway-modal .gd-modal__content > div:first-child {
  overflow: hidden;
  color: var(--gs-foreground);
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-lg);
}

.gd-modal.payment-gateway-modal .gd-modal__content > div:first-child > div:first-child {
  height: auto;
  padding: 18px 22px;
  border-bottom: 1px solid var(--gs-border);
  text-transform: none;
}

.gd-modal.payment-gateway-modal .gd-modal__content > div:first-child > div:first-child > span:first-child {
  color: var(--gs-foreground);
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
}

.gd-modal.payment-gateway-modal .gd-modal__content > div:first-child > div:first-child > span:last-child {
  display: grid;
  width: 36px;
  height: 36px;
  flex: 0 0 auto;
  place-items: center;
  color: var(--gs-muted-foreground);
  border-radius: var(--gs-radius-md);
  transition: background-color 150ms ease, color 150ms ease;
}

.gd-modal.payment-gateway-modal .gd-modal__content > div:first-child > div:first-child > span:last-child:hover {
  color: var(--gs-foreground);
  background: var(--gs-muted);
}
</style>

<script>
import axios from 'axios';
import Auth from '@groovepages/gd-lib/auth';
import {
  required,
  maxLength,
} from 'vuelidate/lib/validators';
import Integration from '@/models/Integration';
import createLinkMixin from '@/mixins/createLinkMixin';
import { userRegion } from '@/utils';
import InfoIcon from '@/assets/images/icons/InfoIcon.svg';
import StripeLogoIcon from '@/assets/images/logo/StripeLogoIcon.svg';
import PaypalLogoIcon from '@/assets/images/logo/PaypalLogoIcon.svg';
import { CommasEnvironmentSelect } from '../../../groove-ui-kit-v2/src/vue2/commas-environment-select';
import { prepareCommasFields, commasDetailsFromFields } from '../../../groove-ui-kit-v2/src/vue2/commas-integration-form';

export default {
  name: 'PaymentGateway',
  mixins: [createLinkMixin],
  components: {
    InfoIcon,
    StripeLogoIcon,
    PaypalLogoIcon,
    CommasEnvironmentSelect,
  },
  props: {
    localGatewayList: {
      required: true,
    },
  },
  data() {
    return {
      userRegion,
      widthModal: '680px',
      paymentIntegrations: [],
      userData: {},
      selectedIntegrationTitle: '',
      selectedIntegrationType: '',
      selectedIntegrationName: '',
      formfields: [],
      showIntegrationForm: false,
      localGatewayIntegrations: this.localGatewayList,
    };
  },
  validations: {
    formfields: {
      $each: {
        value: {
          required,
        },
      },
    },
    selectedIntegrationName: {
      required,
      maxLength: maxLength(100),
    },
    form: {},
  },
  watch: {
    localGatewayIntegrations() {
      this.$emit('updateIntegration', this.localGatewayIntegrations);
    },
  },
  computed: {
    availableIntegrations() {
      if (this.userRegion == 'brazil') {
        return this.paymentIntegrations.filter(el => {
          return ['paypal_commerce', 'stripe', 'commas'].includes(el.name)
        })
      }
      return this.paymentIntegrations.filter((el) => {
        return this.canUseIntegration(el);
      });
    },

    formattedFormfields() {
      if (this.selectedIntegrationType === 'commas') {
        return commasDetailsFromFields(this.formfields);
      }
      const formattedFields = {};

      for (let i = 0; i < this.formfields.length; i++) {
        formattedFields[this.formfields[i].key] = this.formfields[i].value;
      }

      return formattedFields;
    },
  },
  async created() {
    this.userData = Auth.authenticatedUser();
    this.getintegrations();
  },
  methods: {
    openGroovepay() {
      const payAppTitle = this.whitelabelAppData('pay').title.toLowerCase();
      const sellAppTitle = this.whitelabelAppData('sell').title.toLowerCase();

      this.openLink(`https://app.${payAppTitle}.com/?refId=${sellAppTitle}`, '_blank');
    },
    async getintegrations() {
      const { data } = await axios.get(
        `${window.config.apiCoreUrl}/paymentintegrationdata/private`
      );

      this.paymentIntegrations = data.map(integration =>
        integration.name === 'commas'
          ? { ...integration, display_name: 'ScaleGG Pay' }
          : integration
      );
    },
    isGroovester(groove_only) {
      if (!groove_only) {
        return true;
      }
      const { email } = this.userData;
      const address = email.split('@').pop();
      const digitalAppTitle = this.whitelabelAppData('digital')?.title.toLowerCase() || 'groovedigital';

      return address === `${digitalAppTitle}.com`;
    },
    canUseIntegration(integration) {
      if (integration.name === 'commas') {
        // The authenticated API returns Commas only to exact allowlisted users.
        return true;
      }

      return this.isGroovester(integration.groove_only);
    },
    handleIntegrationClick(fields, integration, integration_display_name) {
      switch (integration) {
        case 'paypal_commerce':
          this.ConnectPaypalCommerce();
          break;
        default:
          this.getFields(fields, integration, integration_display_name);
      }
    },
    getFields(fields, name, display_name) {
      this.selectedIntegrationType = name;
      if (name === 'commas') {
        display_name = 'ScaleGG Pay';
        this.selectedIntegrationName = 'ScaleGG Pay';
      }
      this.formFieldsResponse = JSON.parse(fields);
      this.formfields = [];

      for (const prop in this.formFieldsResponse) {
        if (this.formFieldsResponse.hasOwnProperty(prop)) {
          const newFormField = {};
          newFormField.key = this.formFieldsResponse[prop].key;
          newFormField.label = this.formFieldsResponse[prop].label;
          newFormField.value = '';
          if (this.formFieldsResponse[prop].info) newFormField.info = this.formFieldsResponse[prop].info;
          this.formfields.push(newFormField);
        }
      }

      if (name === 'commas') this.formfields = prepareCommasFields(this.formfields);

      this.selectedIntegrationTitle = this.$t(
        'frontend_groovesell_connect_your_account',
        { gateway: display_name }
      );
      this.showIntegrationForm = true;
      // this.$root.$emit('modal-open', 'add-integration-modal');
    },
    async registerIntegration() {
      this.$v.selectedIntegrationName.$touch();
      const isValid1 = !this.$v.selectedIntegrationName.$invalid;

      this.$v.formfields.$touch();
      const isValid2 = !this.$v.formfields.$invalid;
      if (isValid1 && isValid2) {
        this.$loader.start('registerIntegration');
        const newIntegration = new Integration({
          name: this.selectedIntegrationName,
          platform: this.selectedIntegrationType,
          details: this.formattedFormfields,
        });

        const savedIntegrationData = await newIntegration.save();
        const newlyAddedIntegrationData = await Integration.$find(
          savedIntegrationData.data.id
        );
        this.localGatewayIntegrations.push(newlyAddedIntegrationData);
        this.$root.$emit('modal-close', 'payment-gateway-modal');
        this.selectedIntegrationName = '';
        this.$loader.end('registerIntegration');
        this.backToGateway();
      }
    },
    async ConnectPaypalCommerce() {
      this.$loader.start('ConnectPaypalCommerce');
      const funnel_id = this.$route.params.id;
      const { product_id } = this.$route.params;
      this.tokenData = await axios.post('/paypal_commerce', {
        funnel_id,
        product_id,
      });

      const paypalWindow = window.open(
        this.tokenData.data.links[1].href,
        '_blank'
      );

      this.$loader.end('ConnectPaypalCommerce');
      this.$root.$emit('modal-close', 'payment-gateway-modal');
    },
    backToGateway() {
      this.showIntegrationForm = false;
      this.selectedIntegrationTitle = this.$t(
        'frontend_groovesell_paymeny_gateway_list'
      );
    },
  },
};
</script>
